import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible";
import { useActiveChatId } from "@/lib/hooks/useActiveChatId";
import { getMcpServersQueryOptions } from "@/lib/hooks/useMcpServers";
import { getTasksQueryOptions } from "@/lib/hooks/useTasks";
import { usePanelStore } from "@/state/stores";
import type { PanelTab } from "@/state/stores/panelStore";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { McpServersTab, SuggestionsTab, TasksTab } from "./tabs";

export function Drawer() {
  const { activeTab, isPanelOpen } = usePanelStore();
  const queryClient = useQueryClient();
  const activeChatId = useActiveChatId();

  const prefetchAllTabs = useCallback(() => {
    if (!activeChatId) {
      return;
    }

    queryClient.prefetchQuery(getTasksQueryOptions(activeChatId));
    queryClient.prefetchQuery(getMcpServersQueryOptions(activeChatId));
  }, [queryClient, activeChatId]);

  if (!isPanelOpen) {
    return null;
  }

  return (
    <Collapsible open={isPanelOpen}>
      <CollapsibleContent onMouseEnter={prefetchAllTabs}>
        <DrawerContent activeTab={activeTab} />
      </CollapsibleContent>
    </Collapsible>
  );
}

const DrawerContent = ({ activeTab }: { activeTab: PanelTab }) => {
  switch (activeTab) {
    case "suggestions": {
      return <SuggestionsTab />;
    }
    case "mcp-servers": {
      return <McpServersTab />;
    }
    case "tasks": {
      return <TasksTab />;
    }
    default:
      return <SuggestionsTab />;
  }
};
